import { memo } from 'react';
import { number, shape, string, arrayOf } from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import classnames from 'classnames';

import { bookingsSelectors } from '~/api';
import { EntityCard } from '~/elements';
import { getTimeSlotDescription } from '~/routes/utils/helpers';
import { replaceWithNonbreakableSpaces } from '~/utils';

import { TreatmentListDetails } from '../../../../components';
import styles from '../../../../components/treatment-list-details/TreatmentListDetails.scss';

import { AddToCalendarButton } from '~/components';

export const CompletePageTreatmentListDetails = ({ bookingItems }) => (
  <TreatmentListDetails isMultipleAppointment={bookingItems.length !== 1}>
    <ul className={styles.TreatmentList}>
      {bookingItems.map((item) => {
        const { appointmentType, slot, partner, id: bookingReference, price } = item;

        const { date, time } = slot;

        const { name: partnerName } = partner;

        const { name, imageUrl: treatmentCategoryImageSrc } = appointmentType;

        return (
          <li
            className={classnames(styles.TreatmentItem)}
            data-testid="TreatmentItem"
            key={bookingReference}
          >
            <figure className={classnames(styles.TreatmentCategoryThumbnail)}>
              <span
                style={{
                  backgroundImage: `url(${treatmentCategoryImageSrc})`,
                }}
                data-testid="TreatmentCategoryThumbnail"
              />
            </figure>
            <div className={classnames(styles.TreatmentMeta)}>
              <EntityCard title={name} className={styles.TreatmentCard}>
                <div className={styles.TimeSlotDescription} data-testid="TimeSlotDescription">
                  {getTimeSlotDescription(date, time, '•')}{' '}
                  {replaceWithNonbreakableSpaces(`with ${partnerName}`)}
                </div>
                <div className={styles.BookingReference} data-testid="BookingReference">
                  Booking reference: {bookingReference}
                </div>
                <AddToCalendarButton />
                <div className={styles.TreatmentPrice} data-testid="TreatmentPrice">
                  {price}
                </div>
              </EntityCard>
            </div>
          </li>
        );
      })}
    </ul>
  </TreatmentListDetails>
);

CompletePageTreatmentListDetails.propTypes = {
  bookingItems: arrayOf(
    shape({
      id: string.isRequired,
      appointmentType: shape({
        name: string.isRequired,
        imageUrl: string.isRequired,
      }).isRequired,
      partner: shape({
        name: string.isRequired,
      }).isRequired,
      price: string.isRequired,
      slot: shape({
        date: string.isRequired,
        time: shape({
          from: number.isRequired,
          to: number.isRequired,
        }).isRequired,
      }).isRequired,
    }),
  ).isRequired,
};

export const mapStateToProps = createStructuredSelector({
  bookingItems: bookingsSelectors.selectBookingItems,
});

export const ConnectedTreatmentList = connect(mapStateToProps)(
  memo(CompletePageTreatmentListDetails),
);
